module.exports = __webpack_public_path__ + "static/media/acra_wrong.d7d094be.png";